import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "26",
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LuggageIcon',
  setup(__props) {

// No additional logic needed for this icon

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M8.29418 21.5742H17.5369C18.6659 21.5742 19.5811 20.659 19.5811 19.5301V8.83159C19.5811 7.70265 18.6659 6.78745 17.5369 6.78745L8.29418 6.78745C7.16523 6.78745 6.25004 7.70265 6.25004 8.83159L6.25004 19.5301C6.25004 20.659 7.16523 21.5742 8.29418 21.5742Z\" fill=\"var(--primary-blue)\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-miterlimit=\"10\"></path><path d=\"M9.49609 18.3166V10.1641\" stroke=\"white\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"></path><path d=\"M12.873 18.3166V10.1641\" stroke=\"white\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"></path><path d=\"M16.25 18.315V10.1641\" stroke=\"white\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"></path><path d=\"M10.8415 1.75H14.5835C15.127 1.75 15.5694 2.1925 15.5694 2.736V6.63831C15.5694 6.72168 15.5021 6.79062 15.4171 6.79062H10.0078C9.92441 6.79062 9.85547 6.72328 9.85547 6.63831V2.736C9.85547 2.1925 10.298 1.75 10.8415 1.75Z\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.85547 21.7461V23.1281\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6367 21.7461V23.1281\" stroke=\"var(--primary-blue)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>", 7)
  ])))
}
}

})